module.exports = __webpack_public_path__ + "static/media/aboutme_journey.9272d723.png";